import StorageRepository from "./StorageRepository";

export default class LocalStorageRepository<T> extends StorageRepository<T> {
    constructor(key: string) {
        super(key, localStorage);
    }
}
